define('modules/start/dashboard/view',['require','exports','module','env','views/BaseView','./contactsDb/view','./engagement/view','./qualify/view','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");
    var ContactsDbView = require("./contactsDb/view");
    var EngagementView = require("./engagement/view");
    var QualifyView = require("./qualify/view");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        showDashboard: false,
        events: {
            "click #import-contacts-btn": "redirectImportContacts"
        },
        serialize: function() {
            return {
                "showDashboard": this.showDashboard,
                "productsReport": this.productsReport
            };
        },
        beforeRender: function() {
            this.showDashboard = this.products.groupHasService("MDirector") && ((this.productsReport.get("cookies_users") > 0) ||
                (this.productsReport.get("email_users") > 0) ||
                (this.productsReport.get("sms_users") > 0));

            if (this.showDashboard) {
                this.insertView("#products-dashboard-contactsdb", new ContactsDbView({
                    group: this.group,
                    products: this.products,
                    productsReport: this.productsReport
                }));
                this.insertView("#products-dashboard-engagement", new EngagementView({
                    productsReport: this.productsReport
                }));
                this.insertView("#products-dashboard-qualify", new QualifyView({
                    productsReport: this.productsReport
                }));
            }
        },
        redirectImportContacts: function() {
            window.location = Config.mdirectorUrl + "/login?redirect=private[sharp]contacts";
        }
    });

    module.exports = Layout;
});

